import React, { useEffect, useState } from "react";
import api from "../../axiosInstance"; // Adjust this path as per your project

function Investment() {
  const [investmentData, setInvestmentData] = useState([]);
  const parent_id = sessionStorage.getItem('userid');
  useEffect(() => {
    fetchInvestmentData();
  }, []);

  const fetchInvestmentData = async () => {
    try {
      const response = await api.get((`/orderbydistributor/${parent_id}`));
      if (response.status === 200) {
        setInvestmentData(response.data.data);
        console.log("Investment",response.data.data)
      }
    } catch (error) {
      console.error("Error fetching investment data:", error);
    }
  };

  return (
    <div className="container mt-4">
      <h3 className="mb-3">Investment Data</h3>
      <table className="table table-bordered table-striped">
        <thead className="table-dark">
          <tr>
            <th>Order ID</th>
            <th>Distributor Transferable Amount</th>
            <th>Estimate Profit Rate</th>
            <th>Total Sale Amount</th>
            <th>Transferred Profit</th>
            <th>Remaining Investment Balance</th>
          </tr>
        </thead>
        <tbody>
          {investmentData.map((investment, index) => (
            <React.Fragment key={investment.id}>
              <tr style={{ backgroundColor: index % 2 === 0 ? "#f8f9fa" : "#e9ecef" }}>
                <td>{investment.orderid}</td>
                <td>{investment.distributor_transferrable_amount}</td>
                <td>{investment.estimate_profit_rate}%</td>
                <td>{investment.total_sale_amount}</td>
                <td>{investment.transferred_profit}</td>
                <td>{investment.remaining_investment_balance}</td>
              </tr>
              {/* Display orders related to this investment in a nested row */}
              {investment.orders?.map((order) => (
                <tr key={order.id} className="table-secondary">
                  <td colSpan="3">Order Product ID: {order.product_id}</td>
                  <td>Quantity: {order.qty}</td>
                  <td>Buying Price: {order.buying_price}</td>
                  <td>Selling Price: {order.selling_price}</td>
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Investment;
